import React, {useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Rating } from "react-simple-star-rating";
import { ButtonLoader } from "../../utils/Loaders/ButtonLoader";
import { useFetch } from "../../api/FetchApiData";

export default function Avis({avis={note:2.5,text:'',auther:'Vous'},article=null, isNew=false})
{
    const [_avis,setAvis] = useState(avis)
    const {t} = useTranslation();
    const [article_,setArticle] = useState(article);
    const [loading_,setLoading] = useState(false);
    const fetchData = useFetch();

    useEffect(()=>{
        if(!!article)
            setArticle(article);
    },[article])

    const SendAvis = (avis)=>{
            delete avis.auther;
            setLoading(true);
            avis = {...avis,article:Number(article_)};
            console.log(article_);
            fetchData.PostData(avis,'avis/article/').then((result)=>{
                setLoading(false);
            })
        }


    if(isNew)
    {
        return(<div style={{padding:'10px',marginBottom:'30px'}}>
                    <div style={{marginLeft:'20px'}}>
                        <span style={{marginRight:'20px'}}>{isNew ? 'Votre avis' : _avis.auther} :</span> 
                        <Rating initialValue={_avis.note} size={15} onClick={e=>{setAvis({..._avis,note:e})}} onPointerEnter={e=>{}} onPointerLeave={e=>{}} onPointerMove={e=>{}} />
                    </div>
                    <textarea onChange={(e)=>{setAvis({..._avis,text:e.target.value})}} placeholder="Que pensez-vous de ce produit ?" id="textbox" style={{width:'95%',border:'1px solid lightgray',borderRadius:'5px',textAlign:'center',minHeight:'70px'}}></textarea>
                    <div style={{border:'none',margin:'10px 30px 10px 10px',height:'30px',width:'100px',borderRadius:'5px',float:'inline-end'}}>
                        <ButtonLoader style={{fontSize:'x-small',backGroundColor:'lightblue'}} onSubmit={e=>{SendAvis(_avis)}} loading={loading_}  text={t('authentication.envoyer')} />
                    </div>
            </div>);
    }
    else
    {
        return(
        <div style={{marginTop:"10px"}}>
            <div style={{marginLeft:'10px'}}>
                <span style={{marginRight:'20px'}}>{_avis.auther} :</span> 
                <Rating size={15} readonly={true} initialValue={_avis.note} onClick={e=>{}} onPointerEnter={e=>{}} onPointerLeave={e=>{}} onPointerMove={(index)=>{}} />
            </div>
            <p id="textbox" style={{borderRadius:'5px',fontSize:'small',marginTop:'2px',padding:'10px',color:'gray',border:'1px solid lightgray'}}>{_avis.text}</p>
        </div>);
    }
}